import { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleCustomButton from './GoogleCustomButton';

function Google({
  authSuccess, authError,
}) {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  
  if (!process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID) return null;

  return (
    <GoogleOAuthProvider
      clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}
      onScriptLoadError={() => setScriptLoaded(false)}
      onScriptLoadSuccess={() => setScriptLoaded(true)}
    >
      {scriptLoaded && (
        <div className="flex-grow-1">
          <GoogleCustomButton
            authSuccess={authSuccess}
            authError={authError}
          />
        </div>
      )}
    </GoogleOAuthProvider>
  );
}

export default Google;
